<template>
  <div class="reports" v-loading="loading">
    <el-badge class="large" :value="reports.peaCount">
      <h1>PEAs by {{ title }} <span class="filteredBy" v-if="filter"><small>(filtered by {{ filter }})</small></span></h1>
    </el-badge>
    <!-- <a style="margin-left: 50px;" href="#" @click.prevent="clearReports">Run New Report</a> -->
    <div class="groupInfo">
      <strong>Estimated Cost:</strong> ${{ formatMoney(reports.totalNetExpenditure) }}
      <strong>Cost To Date:</strong> ${{ formatMoney(reports.totalCostToDate) }}
      <el-button type="primary" icon="el-icon-document" style="margin-left: 30px; position: relative; top: -2px;" @click="exportDialog = true">Export report</el-button>
      <el-dialog :visible.sync="exportDialog" title="Export Report">
        <export-report :reports="reports" :reportType="reportType" />
      </el-dialog>
    </div>
    <br>
    <el-alert v-if="alertTitle !== ''"
      :title="alertTitle"
      :type="alertType"
      :description="callInfo"
      :closable="false"
      show-icon>
    </el-alert>
    <report-groups v-if="reportType" :reportsData="reports"
    :reportTypes="reportType" :componentIndex="0"/>

  </div>
</template>

<script>
import helperMethods from '@/components/utility/helperMethods.js'
import router from '@/router'
import { groupingReportFilter } from '@/components/utility/groupingReportFilter.js'
export default {
  mixins: [groupingReportFilter],
  data () {
    return {
      reports: {peaCount: 0},
      loading: true,
      reportType: '',
      exportDialog: false,
      filterLabel: [],
      callInfo: '',
      alertType: '',
      alertTitle: ''
    }
  },
  computed: {
    title: function () {
      if (typeof this.reportType === 'object' && this.reportType.length) {
        var groupBy = this.reportType.map(type => {
          return this.capitalize(type)
        })
        return groupBy.join(' then by ')
      } else {
        var title = this.reportType
        if (this.reportLabel) {
          title = this.reportLabel
        }
        return this.capitalize(title)
      }
    },
    query: function () {
      return this.$route.params.query
    },
    queryParams: function () {
      return this.query.split('&')
    },
    reportTypeData: function () {
      var reportType = this.queryParams[0].split('=')[1]
      if (reportType.split(',').length > 1) {
        return reportType.split(',')
      } else {
        return reportType
      }
    },
    filter: function () {
      var eachFilter = this.queryParams[1].split('=')[1].split(',')
      let label = ''
      eachFilter.forEach(f => {
        var filterSplit = f.split(':')
        var filterType = filterSplit[0]
        var filterId = filterSplit[1]
        if (filterType === 'deptId') filterType = 'department'
        if (filterType === 'divisionId') filterType = 'division'
        // eslint-disable-next-line
        if (this.changeFilterDisplayType(filterId, filterType) !== undefined) {
          // eslint-disable-next-line
          this.filterLabel.push(this.changeFilterDisplayType(filterId, filterType))
        }
      })
      var labelSet = [...new Set(this.filterLabel)]
      if (labelSet.length > 1) {
        for (var i = 0; i < labelSet.length; i++) {
          if (labelSet[i] !== undefined) {
            label += labelSet[i] + ', '
          }
        }
      } else if (labelSet.length === 1) {
        return labelSet[0]
      }
      return label
    },
    reportLabel: function () {
      if (this.queryParams[2]) {
        return this.queryParams[2].split('=')[1]
      }
    }
  },
  methods: {
    formatMoney: function (money) {
      return helperMethods.formatMoney(parseFloat(money))
    },
    capitalize: function (input) {
      return input.charAt(0).toUpperCase() + input.slice(1)
    },
    formatDate: function (date) {
      return helperMethods.formatDate(helperMethods.convertDatetoISO(date))
    },
    selectRow: function (row) {
      router.push('/editPea/' + row.id)
    },
    openPanels: function (group) {
      if (group.groups) {
        group.groups.forEach(subGroup => {
          this.$set(subGroup, 'panelOpen', true)

          if (subGroup.groups) {
            this.openPanels(subGroup)
          }
        })
      }
    },
    getReports: function () {
      this.loading = true
      this.$axios.get('/reportPEAs/?' + this.query).then(response => {
        if (response.data !== 'No Data') {
          this.reports = response.data
          this.reportType = this.reportTypeData
          this.loading = false

          // set panelOpen for each group
          this.openPanels(this.reports)
          this.loading = false
        } else {
          this.loading = false
          this.$notify({
            type: 'info',
            title: 'No PEAs were found',
            message: 'No PEAs were found that match your criteria'
          })
        }
      }).catch(reject => {
        this.loading = false
        helperMethods.showNotification(this, 'Error getting report', reject.body, 'error', 30000, '')
      })
    }
  },
  created: function () {
    this.getReports()
  }
}
</script>

<style lang="css">
.pea-panel .groupInfo {
  margin-top: -20px;
}

.el-table {
  margin: 10px 0;
}

.filteredBy {
  color: #777;
  font-size: .85em;
}

.el-table__body tr:hover {
  cursor: pointer;
}
</style>

<style>
.el-badge.large .el-badge__content {
font-size: 18px;
padding-top: 1px;
padding-bottom: 1px;
line-height: normal;
height: auto;
border-radius: 100px;
right: 0;
}

.group {
position: relative;
margin-bottom: 20px;
}

.groupInfo strong:not(:first-child) {
margin-left: 30px;
}

.group .el-badge {
margin: -10px 0 0 5px;
}

.group .group {
  margin-top: 20px;
  margin-bottom: 10px;
}

.group .group h3 {
  background-color: #91b9c1;
  border-radius: 8px 8px 0 0;
}

.group .group h3.closed {
  border-radius: 8px;
}

.group .group .pea-panel {
  border-color: #91b9c1;
  border-radius: 0 0 8px 8px;
}

.group .group .group {
  margin-top: 20px;
  margin-bottom: 10px;
}

.group .group .group h3 {
  background-color: #91c1b4;
  border-radius: 6px 6px 0 0;
}

.group .group .group h3.closed {
  border-radius: 6px;
}

.group .group .group .pea-panel {
  border-color: #91c1b4;
  border-radius: 0 0 6px 6px;
}

.group .group .group .group {
  margin-top: 20px;
  margin-bottom: 10px;
}

.group .group .group .group h3 {
  background-color: #b2c3bf;
  border-radius: 4px 4px 0 0;
}

.group .group .group .group h3.closed {
  border-radius: 4px;
}

.group .group .group .group .pea-panel {
  border-color: #b2c3bf;
  border-radius: 0 0 4px 4px;
}

.reports .el-loading-mask {
  right: -40px;
  left: -40px;
  top: -40px;
}
</style>
